// extracted by mini-css-extract-plugin
export default {"arrowRight3":"Services_arrowRight3__onmUo","arbitration":"Services_arbitration__47B57","services":"Services_services__2BB12"};